import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { promise } from 'protractor';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import * as whiteLabelParameter from '../../../assets/whiteLabelParameter/whiteLabel.json';
import { WhiteLabelParameter } from '../models/white-label-model';
const WHITE_LABEL_SETTINGS_LOCATION =
  '../../../assets/whiteLabelParameter/whiteLabel.json';

@Injectable({
  providedIn: 'root',
})
export class WhiteLabelJsonService {
  defaultCompanyParameter = environment.company;
  whiteLabelJsonObject: WhiteLabelParameter[];
  resultKey: string;
  jsonObject;

  constructor(public http: HttpClient) {}

  getKeyJsonParameter(jsonKey?) {
    return this.getJSON().then((result: any) => {
      this.whiteLabelJsonObject = result;
      this.resultKey = this.whiteLabelJsonObject.filter(
        (x) => x.company === this.defaultCompanyParameter
      )[0][jsonKey];
      return this.resultKey;
    });
  }

  public getJSON(): Promise<WhiteLabelParameter> {
    return this.http
      .get<WhiteLabelParameter>(WHITE_LABEL_SETTINGS_LOCATION)
      .toPromise();
  }
}
